export class Task {
    taskId: string;
    projectId: string;
    title: string;
    description?: string;
    taskstate?: string;
    responsible?: string;
    stageId?: string;
    stagename?: string;
    startdate?: string;
    duedate?: string;
    creator: string;
    created: string;
    versioncreator: string;
    validfrom: string;
    validto: string;
    taskvisibility: string = 'Shared';
    projectname: string;
    projectdescription: string;
    organizationId: string;
    organizationname: string;
    orgdesc: string;
    orgemail: string;
    orgwww: string;
    orglogourl: string;
    customer: string;
    customername: string;
    show: boolean;
    canEdit: boolean;
    sortOrder: number;
    numberoffiles: number;
    tasktype: string = 'task';
    linkurl: string;
    linktext: string;
    uploadFields?: string[]; // list of names of fields that should be treated as file uploads
    formTemplateId?: string; // Form template ID when tasktype='form'
    formTemplateVersion?: number; // Form template version when tasktype='form'
    formTemplateName?: string; // Form template name for display purposes
    completed_date?: string;  // ISO date when task was marked as Done
}